import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'product-item-price-group',
  props: {
    isDistributor: { type: Boolean },
    minSalePrice: null,
    minThPrice: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})